import './App.css'
import { SnackbarProvider } from 'notistack'
import AppAuthProvider from './components/providers/AppAuthProvider/AppAuthProvider'
import Layout from './components/layout/Layout'
import { BrowserRouter as Router } from 'react-router-dom'
import AppRouting from './components/providers/AppRouting'
import ActivationObjectProvider from './components/providers/ActivationObjectProvider/ActivationObjectProvider'
import AppQueryProvider from './components/providers/AppQueryProvider'
import { cs } from 'date-fns/locale'

import { CssBaseline, ThemeProvider } from '@mui/material'
import { theme } from './styles/theme'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { csCZ } from '@mui/x-date-pickers/locales'
import { CssPriorityProvider } from './components/providers/CssPriorityProvider'

const App = () => {
    return (
        <Router>
            <AppQueryProvider>
                <CssPriorityProvider>
                    <CssBaseline />
                    <ThemeProvider theme={theme}>
                        <SnackbarProvider>
                            <AppAuthProvider>
                                <ActivationObjectProvider>
                                    <LocalizationProvider
                                        adapterLocale={cs}
                                        dateAdapter={AdapterDateFns}
                                        localeText={{
                                            ...csCZ.components
                                                .MuiLocalizationProvider
                                                .defaultProps.localeText,
                                            todayButtonLabel: 'Nyní',
                                        }}
                                    >
                                        <Layout>
                                            <AppRouting />
                                        </Layout>
                                    </LocalizationProvider>
                                </ActivationObjectProvider>
                            </AppAuthProvider>
                        </SnackbarProvider>
                    </ThemeProvider>
                </CssPriorityProvider>
            </AppQueryProvider>
        </Router>
    )
}

export default App
